import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './projects.css'

const Projects = (props) => {
  return (
    <div id={props.projectsId} className="projects-container1">
      <span className="projects-title">
        {props.projectsTitle ?? (
          <Fragment>
            <span className="projects-text26">Projects</span>
          </Fragment>
        )}
      </span>
      <span className="projects-text10">
        {props.projectsText ?? (
          <Fragment>
            <span className="projects-text12">
              I’m currently working on several exciting projects — here’s one
              I’m especially passionate about:
            </span>
          </Fragment>
        )}
      </span>
      <div className="projects-container2">
        <img
          alt={props.heimityImageAlt}
          src={props.heimityImageSrc}
          className="projects-image"
        />
        <span className="projects-heimity-title">
          {props.heimityTitle ?? (
            <Fragment>
              <span className="projects-text11">Heimity</span>
            </Fragment>
          )}
        </span>
        <span className="projects-heimity-subtitle1">
          {props.heimitySubtitle ?? (
            <Fragment>
              <span className="projects-text28">
                Find where you truly belong.
              </span>
            </Fragment>
          )}
        </span>
        <span className="projects-heimity-subtitle2">
          {props.heimitySoon ?? (
            <Fragment>
              <span className="projects-text27">
                Heimity is available soon.
              </span>
            </Fragment>
          )}
        </span>
        <span className="projects-heimity-text">
          {props.heimityText ?? (
            <Fragment>
              <span className="projects-text13">
                <span className="projects-text14">Heimity</span>
                <span>
                  {' '}
                  is a smart, cross-platform app that helps individuals and
                  families organize, track, and collaborate on their journey to
                  finding a new home or apartment.
                </span>
                <br></br>
                <br></br>
                <span>
                  House hunting is often overwhelming. Spreadsheets,
                  screenshots, notes, emails, and links — scattered across apps,
                  devices, and people.
                </span>
                <br></br>
                <span className="projects-text20">Heimity</span>
                <span> was created to change that.</span>
                <br></br>
                <span>
                  We believe that
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <span className="projects-text24">finding a home</span>
                <span>
                  {' '}
                  should be a structured, collaborative, and even joyful
                  journey. Heimity brings everything into one intuitive space,
                  helping users track, compare, and share — with confidence and
                  peace of mind.
                </span>
              </span>
            </Fragment>
          )}
        </span>
      </div>
    </div>
  )
}

Projects.defaultProps = {
  heimityTitle: undefined,
  heimityImageAlt: 'image',
  projectsText: undefined,
  projectsId: 'ProjectsId',
  heimityText: undefined,
  heimityImageSrc: '/heimity-700h.webp',
  projectsTitle: undefined,
  heimitySoon: undefined,
  heimitySubtitle: undefined,
}

Projects.propTypes = {
  heimityTitle: PropTypes.element,
  heimityImageAlt: PropTypes.string,
  projectsText: PropTypes.element,
  projectsId: PropTypes.string,
  heimityText: PropTypes.element,
  heimityImageSrc: PropTypes.string,
  projectsTitle: PropTypes.element,
  heimitySoon: PropTypes.element,
  heimitySubtitle: PropTypes.element,
}

export default Projects
